import { cn } from "../../../Utils/helper";

export default function Button({
    text,
    icon,
    onClick,
    iconRight,
    maxWidth,
    className,
    iconSub,
    disabled = false,
}) {
    return (
        <div
            className={cn(
                "flex gap-2.5 items-center px-4 mt-2.5 w-full",
                maxWidth ? `max-w-${maxWidth}` : "w-full", // Sửa lỗi typo "m-w-" thành "max-w-"
                "border border-solid min-h-[42px]",
                className,
                disabled && "opacity-50 cursor-not-allowed"
            )}
            role="button"
            tabIndex={0}
            onClick={!disabled ? onClick : undefined} // Chỉ kích hoạt onClick khi disabled là false
            onKeyPress={(e) => {
                if (!disabled && e.key === "Enter") onClick(); // Chỉ kích hoạt khi disabled là false
            }}
        >
            {icon ? (
                <img
                    loading="lazy"
                    src={icon}
                    alt=""
                    className="object-contain shrink-0 self-stretch my-auto w-5 aspect-square"
                />
            ) : (
                <></>
            )}
            <div
                className={`flex gap-[6px] items-center justify-center m-auto`}
            >
                {iconSub ? (
                    <img
                        loading="lazy"
                        src={iconSub}
                        alt=""
                        className="object-contain shrink-0 self-stretch my-auto w-6 aspect-square"
                    />
                ) : (
                    <></>
                )}
                {text}
            </div>

            {iconRight ? (
                <img
                    loading="lazy"
                    src={iconRight}
                    alt=""
                    className="object-contain shrink-0 self-stretch my-auto w-5 aspect-square"
                />
            ) : (
                <div></div>
            )}
        </div>
    );
}
